import React from 'react';
import { Heart } from 'lucide-react';
export function Footer() {
  return <footer className="bg-brand-cream-dark/30 py-12 border-t border-brand-cream-mid" data-id="element-127">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center text-center" data-id="element-128">
        <div className="font-serif text-2xl font-bold text-brand-brown mb-4" data-id="element-129">
          Pretty Pets{' '}
          <span className="text-brand-rose text-sm font-sans tracking-widest" data-id="element-130">
            PRO KIT
          </span>
        </div>

        <p className="text-brand-brown/70 mb-8 flex items-center gap-2 justify-center" data-id="element-131">
          Hecho con{' '}
          <Heart size={16} className="text-brand-rose fill-brand-rose" data-id="element-132" /> para
          amantes de las mascotas
        </p>

        <div className="flex flex-wrap justify-center gap-6 text-sm text-brand-brown/60 mb-8" data-id="element-133">
          <a href="#" className="hover:text-brand-rose transition-colors" data-id="element-134">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-brand-rose transition-colors" data-id="element-135">
            Políticas de Privacidad
          </a>
          <a href="#" className="hover:text-brand-rose transition-colors" data-id="element-136">
            Contacto
          </a>
        </div>

        <div className="text-xs text-brand-brown/50" data-id="element-137">
          &copy; {new Date().getFullYear()} Pretty Pets. Todos los derechos
          reservados.
          <br className="sm:hidden" data-id="element-138" /> Este sitio no es parte del sitio web de
          Facebook o Facebook Inc.
        </div>
      </div>
    </footer>;
}